
import withErrorBoundary from "../../_shared/helpers/withErrorBoundary";
import IComponentProps from "../../../interfaces/IComponentProps";
import ShareModel from '../../../models/ShareModel';

export function ShareRender(props: (ShareModel & IComponentProps)){
    return (<>
    </>);
}
export default withErrorBoundary(ShareRender);